import type { User } from '@auth0/auth0-react'

export function getUserPicture(user: string | User | undefined) {
  return typeof user === 'string' ? undefined : user?.picture
}
